import styled from 'styled-components/macro';

export const ReadMoreBtn = styled.button`
  margin-left: 0.5rem;
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.primary};
`;
